// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__s_Rgx","spinIcon":"Spinner_spinIcon__GAUTY","spin":"Spinner_spin__C_oYT"};